import { RelatedIndustry } from '@/domain/products/types';
import { Chip } from '@andritzot/metris-web-ui/data-display/chip';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import React, { Fragment } from 'react';

interface IndustriesContentProps {
  productIndustries: RelatedIndustry[];
}

const IndustriesContent: React.FC<IndustriesContentProps> = ({ productIndustries }) => {
  return (
    productIndustries?.length > 0 && (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', m: 2, gap: 2 }}>
        {productIndustries?.map((industry) => (
          <Fragment key={industry.idIndustry}>
            {industry.industryArea ? (
              <Chip
                label={`${industry.industry} - ${industry.industryArea?.industryArea}`}
                variant="outlined"
                color="primary"
              />
            ) : (
              <Chip label={industry.industry} variant="outlined" color="primary" />
            )}
          </Fragment>
        ))}
      </Box>
    )
  );
};

export default IndustriesContent;
